var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.853 15.1465L11.423 10.7165C11.936 10.1205 12.357 9.43749 12.629 8.66749C12.722 8.40649 12.585 8.12149 12.325 8.02849C12.062 7.93549 11.778 8.07349 11.687 8.33349C10.912 10.5265 8.82702 12.0005 6.49902 12.0005C3.46702 12.0005 0.999023 9.53249 0.999023 6.50049C0.999023 3.46749 3.46702 1.00049 6.49902 1.00049C8.82702 1.00049 10.912 2.47349 11.687 4.66749C11.779 4.92749 12.063 5.06549 12.325 4.97149C12.585 4.87849 12.722 4.59349 12.629 4.33349C11.713 1.74149 9.25002 0.000488281 6.49902 0.000488281C2.91502 0.000488281 -0.000976562 2.91649 -0.000976562 6.50049C-0.000976562 10.0845 2.91502 13.0005 6.49902 13.0005C8.08402 13.0005 9.56202 12.4085 10.715 11.4225L15.146 15.8535C15.244 15.9515 15.372 16.0005 15.499 16.0005C15.627 16.0005 15.755 15.9515 15.853 15.8535C16.048 15.6585 16.048 15.3415 15.853 15.1465Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4746b1c6.svg";
export { ForwardRef as ReactComponent };